import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

// Import your images
import img0 from "./Cloudimages/cashback.png";
import img1 from "./Cloudimages/allmobile.png";
import img2 from "./Cloudimages/sheadulingbook.png";
import img3 from "./Cloudimages/Image.png";
import img4 from "./Cloudimages/sequare.png";
import img5 from "./Cloudimages/logistics-about.png";
import img6 from "./Cloudimages/oofers.png";

const DigitalMenuSection = ({ setShowLogin, setIsSignup, isLoggedIn }) => {


  const sections = [
    {
      title: "All-in-One Platform",
      desc: "Maamaas revolutionizes convenience by offering a comprehensive ecosystem where users can seamlessly book services, order food, purchase groceries, plan events, arrange travel, and access numerous other services from a single application. This unified approach eliminates app clutter while providing exceptional time-saving efficiency and streamlined user experience across all lifestyle needs.",
      img: img1
    },
    {
      title: "Multi Cash-Back System",
      desc: "Our innovative reward structure provides cashback on every transaction, whether ordering food or booking services. These rewards function as universal currency redeemable across Maamaas' extensive service network. This creates continuous value for users while encouraging exploration of our diverse offerings, making every purchase more rewarding and financially sensible.",
      img: img0
    },
    {
      title: "Smart Booking & Scheduling",
      desc: "Advanced scheduling capabilities allow users to reserve tables, place future orders, schedule deliveries, and plan services with precision. Our intelligent system manages time slots, availability, and preferences to ensure seamless arrangements. This forward-planning functionality empowers users to organize their lives efficiently while guaranteeing service availability.",
      img: img2
    },
    {
      title: "Trusted Service Providers",
      desc: "We maintain rigorous verification standards for all partners including restaurants, caterers, hotels, travel agencies, event teams, and grocery vendors. Each provider undergoes comprehensive screening for quality, reliability, and service excellence. This commitment ensures consistent, high-standard experiences across all transactions within our trusted ecosystem.",
      img: img3
    },
    {
      title: "Quick & Secure Payments",
      desc: "Multiple payment options including UPI, credit/debit cards, digital wallets, and net banking are integrated with bank-grade security protocols. Our checkout process combines speed with robust encryption, ensuring transaction safety while minimizing friction. This dual focus on convenience and security builds user confidence for all financial interactions.",
      img: img4
    },
    {
      title: "Live Order & Booking Tracking",
      desc: "Real-time tracking provides minute-by-minute updates on food delivery and service booking status. Users monitor progress through interactive maps and detailed status notifications. This transparency reduces uncertainty, improves planning, and enhances overall satisfaction by keeping users informed throughout the service fulfillment process.",
      img: img5
    },
    {
      title: "Exclusive Deals & Promo Offers",
      desc: "Tailored discount programs cater to various user segments including regular customers, students, families, and corporate accounts. Our personalized promotion engine analyzes user behavior to deliver relevant offers, maximizing value while encouraging continued engagement. These exclusive benefits create tangible savings across service categories.",
      img: img6
    },
  ];

  const openPlayStore = () =>
    window.open("https://play.google.com/store/apps?id=com.maamaas.app", "_blank");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSignupPopup, setShowSignupPopup] = useState(false);




  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    @keyframes arrowBlink {
      0% {
        transform: translateX(0);
        opacity: 0.4;
      }
      100% {
        transform: translateX(8px);
        opacity: 1;
      }
    }
  `;
    document.head.appendChild(style);
  }, []);

  const openSignup = () => {
    setShowSignupPopup(true);
  };
  return (
    <div style={styles.container}>
      {/* MAIN HEADER */}
      <div style={styles.header}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ position: "relative", display: "inline-block" }}
        >
          <p style={styles.mainHeading}>
            Why <span style={styles.highlight}>Maamaas?</span>
          </p>

          {/* Animated Underline */}
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "70%" }}
            transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
            style={{
              height: "2px",
              background: "#ee6521",
              borderRadius: "4px",
              marginTop: "6px",
              marginLeft: "auto",
              marginRight: "auto", // ★ center alignment
            }}
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          style={styles.subHeading}
        >
          Your Everyday Needs in One Place — Order, Book, Save, and Earn Cashbacks
        </motion.p>
      </div>

      {/* SECTIONS - One by One with Alternating Layout */}
      <div style={styles.sectionsWrapper}>
        {sections.map((section, index) => (
          <motion.div 
  key={index}
  style={styles.sectionCardWrapper}   // ⬅ ADD CARD WRAPPER HERE
>

  <motion.div
    initial={{
      x: index % 2 === 0 ? -50 : 50,
      opacity: 0,
      scale: 0.95
    }}

            whileInView={{
              x: 0,
              opacity: 1,
              scale: 1
            }}
            transition={{
              duration: 0.7,
              ease: "easeOut",
              delay: index * 0.1
            }}
            viewport={{ once: true, margin: "-50px" }}
            style={{
              ...styles.sectionContainer,
              marginBottom: index === sections.length - 1 ? "0" : "20px",
              flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
            }}
          >
            {/* IMAGE SECTION - Same size for all */}
            <div style={styles.imageWrapper}>
              <div style={styles.imageFrame}>
                <img
                  src={section.img}
                  alt={section.title}
                  style={styles.sectionImage}
                  loading="lazy"
                />
                <div style={{
                  ...styles.imageDecoration,
                  background: index % 2 === 0
                    ? "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)"
                    : "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)"
                }} />
              </div>
              {/* <div style={styles.sectionNumber}>
                <span style={styles.numberText}>0{index + 1}</span>
              </div> */}
            </div>

            {/* CONTENT SECTION - Same size for all */}
            <div style={styles.contentWrapper}>
              <div style={styles.contentInner}>
                <div style={styles.titleRow}>
                  <div style={{
                    ...styles.titleIcon,
                    background: index % 2 === 0
                      ? "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)"
                      : "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)"
                  }}>
                    <span style={styles.iconText}>{index + 1}</span>
                  </div>
                  <h2 style={styles.sectionTitle}>{section.title}</h2>
                </div>

                <p style={styles.sectionDescription}>
                  {section.desc}
                </p>

                <div style={styles.buttonContainer}>
  {!isLoggedIn && (
    <button
      style={{
        ...styles.signupBtn,
        background: index % 2 === 0
          ? "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)"
          : "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)",
        padding: window.innerWidth <= 600 ? "8px 14px" : "12px 22px",     // ⬅ mobile me small
        fontSize: window.innerWidth <= 600 ? "13px" : "16px",             // ⬅ text small
        borderRadius: window.innerWidth <= 600 ? "6px" : "10px",          // ⬅ corner small for mobile
      }}
      onClick={() => {
        setShowLogin(true);
        setIsSignup(true);
      }}
    >
      <span
        style={{
          ...styles.btnText,
          fontSize: window.innerWidth <= 600 ? "13px" : "16px",            // ⬅ text small
        }}
      >
        Sign Up
      </span>

      <span
        style={{
          ...styles.arrowBlink,
          fontSize: window.innerWidth <= 600 ? "15px" : "20px",            // ⬅ arrow small
          marginLeft: window.innerWidth <= 600 ? "6px" : "10px",
        }}
      >
        ➜
      </span>
    </button>
  )}
</div>

              </div>
            </div>
          </motion.div>
          </motion.div>
        ))}
      </div>


    </div>
  );
};

const styles = {
  sectionCardWrapper: {
  // background: "#fff",
  padding: "10px",
  borderRadius: "25px",
  // boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
  marginBottom: "30px",
  width :"100%",
},

  container: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#faf9ff",
    padding: "60px 5%",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    position: "relative",
    overflow: "hidden",
  },

  header: {
    textAlign: "center",
    marginBottom: "32px",
    marginTop: "-57px",
    padding: "0 20px",
  },

  mainHeading: {
    fontSize: "clamp(3rem, 5vw, 4rem)",
    fontWeight: "800",
    color: "#222",
    marginBottom: "20px",
    letterSpacing: "-1px",
    lineHeight: "1.1",
  },

  highlight: {
    background: "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },

  subHeading: {
    fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
    color: "#666",
    maxWidth: "1200px",
    margin: "0 auto",
    lineHeight: "1.6",
    fontWeight: "400",
    opacity: 0.9,
  },

  sectionsWrapper: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px 0",
  },

  sectionContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0px",
    width: "100%",
    minHeight: "400px",
    position: "relative",
  },

  imageWrapper: {
    flex: "1",
    minWidth: "0",
    position: "relative",
  },

  imageFrame: {
    position: "relative",
    height: "400px",  // 🔽 500px se 400px
    overflow: "hidden",
    borderRadius: "25px",
  },


  sectionImage: {
    width: "100%",
    height: "100%",     // 🔽 81% hatao
    objectFit: "contain",   // 🔽 cover ki jagah contain / product style look
    transition: "transform 0.6s ease",
  },


  imageDecoration: {
    position: "absolute",
    top: "20px",
    left: "20px",
    right: "-20px",
    bottom: "-20px",
    borderRadius: "25px",
    opacity: 0.1,
    zIndex: -1,
    filter: "blur(10px)",
  },

  sectionNumber: {
    position: "absolute",
    top: "-20px",
    right: "-20px",
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 30px rgba(177, 92, 214, 0.3)",
    zIndex: 2,
  },

  numberText: {
    fontSize: "2rem",
    fontWeight: "800",
    color: "white",
    opacity: 0.9,
  },

  contentWrapper: {
    flex: "1",
    minWidth: "0",
  },

  contentInner: {
    padding: "50px",
    // background: "white",
    // borderRadius: "25px",
    // boxShadow: "0 15px 40px rgba(0, 0, 0, 0.05)",
    // border: "1px solid rgba(177, 92, 214, 0.1)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "25px",
  },

  titleIcon: {
    width: "50px",
    height: "50px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "0 8px 20px rgba(177, 92, 214, 0.2)",
  },

  iconText: {
    color: "white",
    fontSize: "1.5rem",
    fontWeight: "700",
  },

  sectionTitle: {
    fontSize: "clamp(1.8rem, 2.5vw, 2.2rem)",
    fontWeight: "800",
    color: "#222",
    margin: 0,
    letterSpacing: "-0.5px",
    lineHeight: "1.2",
  },

  sectionDescription: {
    fontSize: "1.05rem",
    lineHeight: "1.8",
    color: "#555",
    marginBottom: "35px",
    flex: 1,
    fontWeight: "400",
     textAlign: "justify",
  },

  buttonContainer: {
    marginTop: "auto",
  },

  signupBtn: {
    border: "none",
    padding: "16px 28px",
    borderRadius: "50px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "transform 0.3s ease",
    boxShadow: "0px 8px 15px rgba(0,0,0,0.15)",
  },

  btnText: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#fff",
    letterSpacing: "0.5px"
  },

  arrowBlink: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#fff",
    animation: "arrowBlink 0.8s infinite alternate ease-in-out",
  },

  btnText: {
    fontSize: "1.1rem",
    fontWeight: "700",
    marginBottom: "4px",
    color: "#fff",
  },



  btnSubtext: {
    fontSize: "0.85rem",
    opacity: 0.9,
    fontWeight: "400",
  },

  finalCta: {
    maxWidth: "1000px",
    margin: "100px auto 0",
    padding: "60px",
    background: "linear-gradient(135deg, rgba(177, 92, 214, 0.05) 0%, rgba(106, 17, 203, 0.05) 100%)",
    borderRadius: "30px",
    border: "2px solid rgba(177, 92, 214, 0.1)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },

  ctaContent: {
    position: "relative",
    zIndex: 2,
  },

  ctaTitle: {
    fontSize: "clamp(2rem, 3vw, 2.5rem)",
    fontWeight: "800",
    color: "#222",
    marginBottom: "20px",
    background: "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },

  ctaDesc: {
    fontSize: "1.2rem",
    color: "#666",
    marginBottom: "40px",
    maxWidth: "600px",
    margin: "0 auto 40px",
    lineHeight: "1.6",
  },

  finalDownloadBtn: {
    padding: "22px 45px",
    borderRadius: "20px",
    background: "linear-gradient(135deg, #ee6521 0%, #ee6521 100%)",
    border: "none",
    color: "white",
    cursor: "pointer",
    fontWeight: "600",
    transition: "all 0.3s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 15px 35px #ee6521",
    ':hover': {
      transform: "translateY(-5px)",
      boxShadow: "0 25px 50px #ee6521",
    },
  },

  btnContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },

  finalBtnText: {
    fontSize: "1.3rem",
    fontWeight: "700",
  },

  finalBtnSub: {
    fontSize: "0.9rem",
    opacity: 0.9,
    fontWeight: "400",
  },

  // Responsive Styles
  '@media (max-width: 1200px)': {
    sectionContainer: {
      gap: "50px",
    },

    imageFrame: {
      height: "320px",
    },

    contentInner: {
      padding: "35px",
    },
  },

  '@media (max-width: 992px)': {
    sectionContainer: {
      flexDirection: "column !important",
      gap: "40px",
      minHeight: "auto",
    },

    imageWrapper: {
      width: "100%",
    },

    imageFrame: {
      height: "300px",
    },

    contentWrapper: {
      width: "100%",
    },

    finalCta: {
      padding: "50px 30px",
      marginTop: "80px",
    },
  },

  '@media (max-width: 768px)': {
    container: {
      padding: "40px 4%",
    },

    header: {
      marginBottom: "60px",
    },

    mainHeading: {
      fontSize: "2.5rem",
    },

    sectionContainer: {
      marginBottom: "60px",
      gap: "30px",
    },

    imageFrame: {
      height: "280px",
      borderRadius: "20px",
    },

    contentInner: {
      padding: "30px",
      borderRadius: "20px",
    },

    titleRow: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "15px",
    },

    sectionTitle: {
      fontSize: "1.6rem",
    },

    sectionDescription: {
      fontSize: "1rem",
    },

    downloadBtn: {
      padding: "16px 30px",
      minWidth: "100%",
    },

    finalCta: {
      padding: "40px 20px",
      marginTop: "60px",
      borderRadius: "25px",
    },

    finalDownloadBtn: {
      padding: "20px 35px",
      width: "100%",
    },
  },

  '@media (max-width: 480px)': {
    container: {
      padding: "30px 3%",
    },

    mainHeading: {
      fontSize: "2rem",
    },

    subHeading: {
      fontSize: "1rem",
    },

    imageFrame: {
      height: "250px",
    },

    sectionNumber: {
      width: "60px",
      height: "60px",
      top: "-15px",
      right: "-15px",
    },

    numberText: {
      fontSize: "1.5rem",
    },

    contentInner: {
      padding: "25px",
    },

    titleIcon: {
      width: "45px",
      height: "45px",
    },

    sectionTitle: {
      fontSize: "1.4rem",
    },

    sectionDescription: {
      fontSize: "0.95rem",
      lineHeight: "1.7",
    },

    ctaTitle: {
      fontSize: "1.6rem",
    },

    ctaDesc: {
      fontSize: "1rem",
    },

    finalBtnText: {
      fontSize: "1.1rem",
    },
  },
};

export default DigitalMenuSection;

